// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
//
// 引入echarts
import echarts from 'echarts'
import axios from 'axios';
// 过滤器
import * as custom from './utils/util'


// 地图
import AMap from 'vue-amap'

Vue.prototype.$echarts = echarts

Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

// 使用element UI
Vue.use(ElementUI);

// console.log(AMap, 'AMap')


AMap.initAMapApiLoader({
  key: 'f9a5255d4477a33fe753ce482bc400ca',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.MouseTool',
    'AMap.Polygon',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.DistrictSearch',
    "AMap.Marker",
    "AMap.Icon",
    "AMap.InfoWindow",
    "AMap.Geocoder",
    "AMap.MouseTool",
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})
Vue.use(AMap)

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})
// 路由守卫


// 路由拦截器
router.beforeEach((to, from, next) => {
  let router_list = JSON.parse(localStorage.getItem('router_list'));
  if (to.matched.length != 0) {
    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
      console.log(localStorage.getItem("token"), 'localStorage.getItem("token")')
      if (localStorage.getItem("token")) { // 判断是否登录
        // if (router_list !== null) {
        //   let flag = '';
        //   for (let i = 0; i < router_list.length; i++) {
        //     if (to.path == router_list[i]) {
        //       flag = true;
        //       break;
        //     } else {
        //       flag = false;
        //     }
        //   }
        //   if (flag) {
        //     console.log(flag, 'flag')
        //     console.log(to, 'to')
        //     console.log(from, 'from')
        //     console.log(next, 'next')
        //     next();
        //   } else {
        //     next({
        //       path: '/' +
        //         'audit/home',
        //     })
        //   }
        // } else {
        //
        //
        //   next();
        // }
        next();
      } else {
        next({
          path: '/login',
          query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
      }
    } else {
      if (localStorage.getItem("token")) { // 判断是否登录
        if (to.path != "/" && to.path != "/login") { //判断是否要跳到登录界面
          // console.log(1)
          next();
        } else {
          /**
           * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页
           */
          next({
            path: '/' +
              'project/list',
          })
        }
      } else {
        next();
      }
    }
  } else {
    next({
      path: '/login',
      query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
    })
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, //使用store vuex状态管理
  components: {App},
  template: '<App/>',
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue()
  }

})



// WEBPACK FOOTER //
// ./src/main.js